const processEnv = typeof process !== "undefined" ? process.env : {};
const windowEnv = window && window.env ? window.env : {};
const env = {
  ...processEnv,
  ...windowEnv,
};
env.REACT_APP_PUBLIC_URL = env.REACT_APP_PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL;

export { env };
